import React, { createContext, useContext } from "react";
import usePoster from "../hooks/use-poster";

interface PosterContextType extends ReturnType<typeof usePoster> {}

const PosterContext = createContext<PosterContextType | null>(null);

export const PosterProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const Poster = usePoster();

  const value = Poster;

  return (
    <PosterContext.Provider value={value}>{children}</PosterContext.Provider>
  );
};

export const usePosterContext = () => {
  const context = useContext(PosterContext);
  if (!context) {
    throw new Error("usePosterContext must be used within PosterProvider");
  }
  return context;
};
